// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".credits--tM5IM{align-items:flex-end;display:flex;flex:1 0 auto;font-size:13px;padding:50px 0 10px 15px}.credits--tM5IM a{margin-left:5px}\n", ""]);
// Exports
exports.locals = {
	"credits": "credits--tM5IM"
};
module.exports = exports;
